import { useState, useEffect } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import api from '../utils/api'

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const resetToken = location.state?.resetToken

  useEffect(() => {
    if (!resetToken) {
      setError('유효하지 않은 접근입니다. 비밀번호 찾기부터 다시 진행해주세요.')
    }
  }, [resetToken])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setMessage('')

    if (!resetToken) {
      setError('유효하지 않은 접근입니다.')
      return
    }

    if (newPassword !== confirmPassword) {
      setError('새 비밀번호가 일치하지 않습니다.')
      return
    }

    if (newPassword.length < 6) {
      setError('비밀번호는 최소 6자 이상이어야 합니다.')
      return
    }

    setLoading(true)

    try {
      await api.post('/auth/reset-password', {
        resetToken,
        newPassword
      })
      setMessage('비밀번호가 성공적으로 재설정되었습니다.')
      
      // 2초 후 로그인 페이지로 이동
      setTimeout(() => {
        navigate('/login')
      }, 2000)
    } catch (err: any) {
      setError(err.response?.data?.error || '비밀번호 재설정에 실패했습니다.')
    } finally {
      setLoading(false)
    }
  }

  if (!resetToken) {
    return (
      <div className="container">
        <div style={{ maxWidth: '400px', margin: '50px auto' }}>
          <div className="card">
            <h2 style={{ marginBottom: '20px', textAlign: 'center' }}>비밀번호 재설정</h2>
            <div className="alert alert-error">{error}</div>
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
              <Link to="/forgot-password">비밀번호 찾기로 돌아가기</Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="container">
      <div style={{ maxWidth: '400px', margin: '50px auto' }}>
        <div className="card">
          <h2 style={{ marginBottom: '20px', textAlign: 'center' }}>비밀번호 재설정</h2>
          
          {message && (
            <div className="alert alert-success" style={{ marginBottom: '20px' }}>
              {message}
              <div style={{ marginTop: '10px', fontSize: '14px' }}>
                로그인 페이지로 이동합니다...
              </div>
            </div>
          )}

          {error && <div className="alert alert-error">{error}</div>}

          {!message && (
            <>
              <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
                새 비밀번호를 입력해주세요.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>새 비밀번호</label>
                  <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    disabled={loading}
                    minLength={6}
                    placeholder="최소 6자 이상"
                  />
                </div>

                <div className="form-group">
                  <label>새 비밀번호 확인</label>
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    disabled={loading}
                    minLength={6}
                    placeholder="비밀번호를 다시 입력하세요"
                  />
                </div>

                <button 
                  type="submit" 
                  className="btn btn-primary" 
                  style={{ width: '100%' }}
                  disabled={loading}
                >
                  {loading ? '재설정 중...' : '비밀번호 재설정'}
                </button>
              </form>
            </>
          )}

          {!message && (
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
              <Link to="/login">로그인으로 돌아가기</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ResetPassword

